function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3838 10.9212C12.549 10.5094 13.3838 9.39814 13.3838 8.09192C13.3838 6.43506 12.0406 5.09192 10.3838 5.09192C8.72693 5.09192 7.38379 6.43506 7.38379 8.09192C7.38379 9.39814 8.2186 10.5094 9.38379 10.9212V14.0919C9.38379 14.6442 9.8315 15.0919 10.3838 15.0919C10.9361 15.0919 11.3838 14.6442 11.3838 14.0919V10.9212ZM9.38379 8.09192C9.38379 8.6442 9.8315 9.09192 10.3838 9.09192C10.9361 9.09192 11.3838 8.6442 11.3838 8.09192C11.3838 7.53963 10.9361 7.09192 10.3838 7.09192C9.8315 7.09192 9.38379 7.53963 9.38379 8.09192Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3838 0.0919189C4.86094 0.0919189 0.383789 4.56907 0.383789 10.0919C0.383789 15.6148 4.86094 20.0919 10.3838 20.0919C15.9066 20.0919 20.3838 15.6148 20.3838 10.0919C20.3838 4.56907 15.9066 0.0919189 10.3838 0.0919189ZM2.38379 10.0919C2.38379 14.5102 5.96551 18.0919 10.3838 18.0919C14.8021 18.0919 18.3838 14.5102 18.3838 10.0919C18.3838 5.67364 14.8021 2.09192 10.3838 2.09192C5.96551 2.09192 2.38379 5.67364 2.38379 10.0919Z",
  fill: "#4979C0"
});

var SvgAdministrator = function SvgAdministrator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdministrator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/administrator.6c6f794c.svg";
export { ForwardRef as ReactComponent };